import { TVimeoRecordWidgetConfiguration } from './VimeoTypes';

const SEISMIC_URL = 'https://seismic.com';
const SEISMIC_LOGO_URL = 'https://seismic.com/wp-content/themes/seismic-2022/assets/images/build/seismic-icon.svg'; //TODO this is temporary solution
const PARTNER_TITLE = 'Seismic Vimeo POC';

export default async function initializeRecorder(accessToken, recorder) {
  const recordConfig: TVimeoRecordWidgetConfiguration = {
    /*
     * REQUIRED
     */
    // The end user’s OAuth 2.0 access token. See the Working with Managed Users at Vimeo PDF for more information.
    // This field is required.
    accessToken: accessToken,
    // The name to display in the user interface. This value must be between 2 and 20 characters.
    // This field is required.
    partnerTitle: PARTNER_TITLE,
    // The URL of your website, including the protocol, as in https://vimeo.com.
    // This field is required.
    connectAccountURL: SEISMIC_URL, // Does this need to be a tenant URL?
    // The URL of your logo image, including the protocol, as in https://vimeo.com/img/logo.jpg. This image appears in the user interface unless
    // you specify an alternate image in the connectAccountIllustration field.
    // This field is required.
    partnerLogoURL: SEISMIC_LOGO_URL,
    /*
     * OPTIONAL
     */
    // An additional domain on which the created video can play. Please note that the video can always play on the domain on which the video is created.
    // partnerDomain: '',

    // The unique user identifier of your platform. We use this value for our internal analytics to gather more accurate usage data and improve your user experience over time.
    // partnerUserId: '',

    // The URI of a Vimeo account corresponding to the owner of a Vimeo team. The recorded video is automatically uploaded to this account for use with the team.
    // teamOwnerUri: '',

    // The host DOM element for Vimeo Record to mount in, such as document.body.
    // rootElement: '',

    // The URL of an alternate image to display in the Vimeo Record user interface, including the protocol, as in https://vimeo.com/img/alt.jpg. This image replaces the one
    // indicated by partnerLogoURL, but its markup in the interface isn’t exactly the same.
    // connectAccountIllustration: '',

    // The language code of the user interface: en, de-DE, es, fr-FR, ja-JP, pt-BR, or ko-KR.
    // language: '',

    // The default title of the recorded video. The title appears on the post-recording screen.
    // defaultVideoTitle: '',

    // The default description of the recorded video. The description appears on the post-recording screen.
    // defaultVideoDescription: '',

    // The activation source of the SDK on your platform. For example, if the SDK is activated by clicking a button in your comments section, you
    // could specify the value of this field as comments. We use this field for internal analytics purposes and ultimately to give you a better user experience.
    // activationSource: '',

    // A set of attributes that controls which buttons appear on the post-recording screen. Set
    // customShareActions.download to true to display the download button;
    // customShareActions.settings to true to display the settings button; and
    // customShareActions.delete to true to display the delete button. Set
    // customShareActions.footer to copyLink to show only the Copy Link button in the footer of this screen. You can also set this field to an
    // array of objects, where each object represents a button to display in the footer. Each object consists of two fields:
    // type (addVideo, discardVideo, copyLink, viewOnVimeo), which controls the button type; and format (primary, secondary, danger, optional,
    // icon), which controls the button styling.
    customShareActions: {
      //   download: false
      //   settings: false,
    },

    // The notifications to display on the pre-recording and post-recording screens. Use customNotifications.preRecording and
    // customNotifications.postRecording for these, and set each of their values to an object with two fields: message, which contains the
    // notification text; and format (info, error), which controls the notification styling. Thenotification text supports Markdown-style
    // hyperlinks, as in [Go to Vimeo](https://vimeo.com).
    customNotifications: {
      // preRecording: {
      //   message: 'Test notification for preRecording. This can be info or error.',
      //   format: 'info'
      // },
      // postRecording: {
      //   message: 'Test notification for postRecording, this can be info or error.',
      //   format: 'info'
      // }
    }

    // A list of custom appearance attributes and their values. See below for more information.
    // The customization field in the initialize() method’s configuration data enables you to set
    // the colors, typefaces, graphical icons, and border radiuses that appear in the instance’s user interface
    // Refer to the SDK’s code listing for an inventory of the many different appearance
    // attributes that you can set. You can find these under the TTheme type definition.
    // this is a non-inclusive list
    // keeping this so we know the shape of customizations
    // TODO: should remove once UVR has been deployed to more tenants
    // customization: {
    //   // mantle fonts: 'ui-monospace,Menlo,Monaco,"Cascadia Mono","Segoe UI Mono","Roboto Mono","Oxygen Mono","Ubuntu Monospace","Source Code Pro","Fira Mono","Droid Sans Mono","Courier New",monospace;'
    //   fonts: {},
    //   icons: {
    //     cameraOn: IconVideo(),
    //     recordingCancel: IconDelete()
    //   },
    //   colors: {
    //     $audioWaves_colorA: '#22092B',
    //     $audioWaves_colorB: '#FE5000',
    //     $recordingMode_background_selected: 'rgb(254, 80, 0, 0.85)',
    //     $item_color_accent_default: '#FE5000'

    //     // Set mantle button defaults https://mantle-ui.seismic.com/#/Forms/Button -- doesn't look great with vimeo UI but we can do it
    //     // $buttonPrimary_background_default: '#07098D',
    //     // $buttonPrimary_background_disabled: '#CFD4DA',
    //     // $buttonPrimary_background_active: '#0065CD'
    //   }
    // }
  };

  await recorder.initialize(recordConfig);
}
